import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { RiskyPregnancyCertificate } from '@app/entities/models/ptrab/certificates/risky-pregnancy.model';

export interface CertificatesUseCases {
  getRiskyPregnancyList(): Observable<RiskyPregnancyCertificate[] | null>;
}

export const CERTIFICATES_USE_CASES = new InjectionToken<CertificatesUseCases>('CERTIFICATES_USE_CASES');
